enum PreventedTags {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
}

export const preventPropagatingInputEvents = (e: KeyboardEvent) => {
  if (PreventedTags[(e?.target as HTMLElement).tagName.toUpperCase()]) {
    e.stopPropagation();
  }
};
